<template>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="description" content="">
    <meta name="author" content="Sylva Foundation">
    <meta name="generator" content="Hugo 0.84.0">
    <title>Forestry and Climate Change Partnership</title>


    <link rel="canonical" href="https://getbootstrap.com/docs/5.0/examples/carousel/">

    
    <!-- Custom styles for this template -->
  </head>
  <body>


  <!-- Marketing messaging and featurettes
  ================================================== -->
  <!-- Wrap the rest of the page in another container to center all the content. -->

<div class="container marketing">
	<div class="row">

    <h3 class="greeni mb-4">
			About
		</h3>
    <div class="col-lg">
    <p>
      The FCCP is a cross-sector unincorporated body that promotes open discussion and seeks to represent a collective view of the forestry and woodland sector on climate adaptation of trees, woods and forests in England. Read our <router-link class="greeni" to="/resources">Terms of Reference</router-link>.
    </p> 
    </div>
    <div class="col-lg">
    <p> 
      The FCCP is the custodian of the <router-link class="greeni" to="/resources">Forestry and Climate Change Accord</router-link>.
    </p>
    <p>  
      The FCCP maintains an <router-link class="greeni" to="/resources">Action Plan</router-link> which translates the principles of the Accord into tangible progress on adaptation.
    </p>
    </div>
	</div>

	<hr class="featurette-divider">

  <div class="row">
    <div class="col-lg mb-3">
      <h5 class="greeni">
      Partnership members
      </h5>
    </div>
    <div class="row mb-3">
      <div class="col-lg">
      <p>
      Membership of the FCCP is inclusive of a broad range of forestry and woodland interests in England including government agencies, landowner organisations, forestry and conservation NGOs, research institutions and private forestry and woodland organisations with an interest in climate change adaptation.
      </p> 
      </div>
      <div class="col-lg">
      <p> 
      Members recognise and respect that the principles of adaptation can be delivered in different ways depending on the landowner’s objectives and site characteristics; strive to find common ground; and aim to speak with a common voice, communicating common messages to their respective networks.
      </p>
      </div>
    </div>
    <members></members>
  </div>

  <hr class="featurette-divider">
  
    <div class="row mb-3">
        <h5 class="greeni">
          Supporters
        </h5>
    </div>
    <div class="row">
      <div class="col-lg mb-3">
        <p>
        The following organisations have signed up as supporters of the Forestry & Climate Change Adaptation Accord. If you would like your organisation to be recognised as a supporter, <a href="https://forms.gle/umd1PsgYRxz15PZJ9">sign up here</a>.
        </p> 
      </div>
      <supporters></supporters>
    </div>


  </div>
      
  </body>
</html>
</template>

<script>

import Members from './Members.vue'
import Supporters from './Supporters.vue'

export default {
  components: { Members, Supporters },
  name: 'About',
  props: {
  }
}
</script>

<style scoped>
</style>